module.exports = __webpack_public_path__ + "img/home.fd88f165.svg";